import { render } from "./TripplyHeader.vue?vue&type=template&id=671347b2"
import script from "./TripplyHeader.vue?vue&type=script&lang=ts"
export * from "./TripplyHeader.vue?vue&type=script&lang=ts"

import "./TripplyHeader.vue?vue&type=style&index=0&id=671347b2&lang=scss"
script.render = render

export default script